/**
 * Neya Systems, LLC disclaims all warranties with regard to this software,
 * including all implied warranties of merchantability and fitness, in no
 * event shall Neya Systems, LLC be liable for any special, indirect or
 * consequential damages or any damages whatsoever resulting from loss of
 * use, data or profits, whether in an action of contract, negligence or
 * other tortious action, arising out of or in connection with the use or
 * performance of this software.
 *
 * "Copyright (c) 2020 Neya Systems, LLC, all rights reserved."
 *
 * This work contains valuable confidential and proprietary information.
 * Disclosure or reproduction without the written authorization of Neya
 * Systems, LLC is prohibited. This unpublished work by Neya Systems, LLC
 * is protected by the laws of the United States and other countries. If
 * publication of the work should occur, the following notice shall apply.
 */

import React from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import {
    NotFoundPage,
    ImprovedSearchPage,
    UploadPage,
    DatasetPage,
    Register,
    CertificateInfoPage
} from '../pages'

const PublicRoute = ({ page: Page, ...rest }) => (
    <Route { ...rest } render={ props => <Page { ...props } /> } />
)

const Router = ({ ...props }) => {
    const { checkingCredentials } = props
    if (checkingCredentials) {
        return <div />
    }

    return (
        <div>
            <Switch>
                <PublicRoute exact path='/' page={ ImprovedSearchPage } />
                <PublicRoute exact path='/dataset/:datasetId' page={ DatasetPage } />
                <PublicRoute exact path='/search' page={ ImprovedSearchPage } />
                <PublicRoute exact path='/upload' page={ UploadPage } />
                <PublicRoute exact path='/welcome' page={ CertificateInfoPage } />
                <PublicRoute exact path='/register-form' page={ Register } />
                <PublicRoute page={ NotFoundPage } />
            </Switch>
        </div>
    )
}

export default (Router)
